const notDeleteKey = "no";
const DataSourceDetailConstants = {
  SET_ROUTE_CONTEXT: "dataSourceDetail/SET_ROUTE_CONTEXT",
  SET_USER_CONTEXT: "dataSourceDetail/SET_USER_CONTEXT",
  SET_PARTIAL_USER_CONTEXT: "dataSourceDetail/SET_PARTIAL_USER_CONTEXT"
};
export {
  DataSourceDetailConstants as default,
  notDeleteKey
};
//# sourceMappingURL=DataSourceDetailConstants.js.map
